// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 738 ? "1484b9de" : chunkId) + "." + {"651":"a67ffb037c215b07","738":"341da6ea0edbeddb","743":"3ca4fd0e02247819"}[chunkId] + ".js";
};